import React from 'react'
import { Button, Field, Input, makeStyles } from '@fluentui/react-components'
import { Control, Controller, UseFormWatch } from 'react-hook-form'
import { Eye20Regular, EyeOff20Regular } from '@fluentui/react-icons'
import { t } from '../../i18n/i18n'
import { OrganisationWithUserAccountsDTO } from '../../api/schemas/schema'

const useStyles = makeStyles({
   personalNumberInput: {
      WebkitTextSecurity: 'disc',
      textSecurity: 'disc',
   },
})

type ControlledPersonalNumberInputProps = {
   name: any
   control: Control<any>
   label?: string
   disabled?: boolean
   required?: boolean
   watch: UseFormWatch<OrganisationWithUserAccountsDTO>
}
export const ControlledPersonalNumberInput = ({ name, control, label, disabled, required, watch }: ControlledPersonalNumberInputProps) => {
   const classes = useStyles()
   const [showPersonalNumber, setShowPersonalNumber] = React.useState(false)

   const toggleShowPersonalNumber = () => {
      setShowPersonalNumber((prev) => !prev)
   }

   const formatText = (value: string) => {
      const cleanedValue = value.replace(/\D/g, '')
      if (cleanedValue.length <= 8) {
         return cleanedValue
      }
      return `${cleanedValue.slice(0, 8)}-${cleanedValue.slice(8, 12)}`
   }

   const userAccounts = watch('userAccounts')
   const users = userAccounts?.map((ua) => ua.user)
   const isUnique = (value: string) => {
      if (users && users.length > 0) {
         const count = users.filter((u) => u.personalNumber === value).length
         if (count > 1) {
            return t('PersonalNumberMustBeUnique')
         }
      }
      return true
   }

   return (
      <Controller
         name={name}
         control={control}
         rules={{
            required: required ? t('RequiredField') : false,
            pattern: {
               value: /^[0-9]*$/,
               message: t('PersonalNumberMustBeNumbersOnly'),
            },
            validate: isUnique,
         }}
         render={({ field: { value, onChange }, fieldState: { error, invalid } }) => {
            return (
               <Field label={label} required={required ?? false} validationMessage={error?.message ?? undefined} validationState={error ? 'error' : undefined}>
                  <>
                     <Input
                        input={{ className: showPersonalNumber ? '' : classes.personalNumberInput }}
                        autoComplete="off"
                        type="text"
                        value={value ? formatText(value.toString()) : ''}
                        onChange={(e, data) => {
                           const rawValue = data.value.replace(/\D/g, '')?.slice(0, 12)
                           onChange(rawValue)
                        }}
                        disabled={disabled ?? false}
                        placeholder={t('PersonalNumberFormat')}
                        contentAfter={
                           <Button
                              appearance="transparent"
                              icon={showPersonalNumber ? <EyeOff20Regular /> : <Eye20Regular />}
                              onClick={toggleShowPersonalNumber}
                           />
                        }
                     />
                  </>
               </Field>
            )
         }}
      />
   )
}
